import React from "react";
import { Controller, useForm } from "react-hook-form";
import EditorSearchIcon from "@atlaskit/icon/glyph/editor/search";

import Api from "../../services/Api";
import { Grid } from "../../UI/Grid";
import { Button } from "../../UI/Button";
import useAuth from "../../routes/login/AuthContext";
import { getControllerTextFieldRender } from "../../helpers/getControllerTextFieldRender";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";

interface IProps {
  onSuccess: (data: any) => void;
}

interface IFormData {
  pin: string;
}

export const UserSearchByPinForm: React.FC<IProps> = (props) => {
  const { getAuthToken } = useAuth();
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);
  const { control, handleSubmit, reset } = useForm<IFormData>({
    defaultValues: {
      pin: "",
    },
  });
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { isEntrata, isAcc } = useSelectedNetworkImportTypes();

  const onSubmit = async (data: IFormData) => {
    setIsLoading(true);

    try {
      const res = await Api.getUserSearchByPin(selectedNetworkId, data.pin.trim(), await getAuthToken());

      props.onSuccess(res);
    } catch (error: any) {
      showErrorSnackbar(error.message);
    }

    reset();
    setIsLoading(false);
  };

  let label = "RMS ID";

  if (isEntrata) {
    label = "Entrata Lease Id or Resident Id";
  }

  if (isAcc) {
    label = "ACC ID";
  }

  return (
    <Grid container spacing={2} alignItems="end" component="form" onSubmit={handleSubmit(onSubmit)}>
      <Grid item>
        <Controller name="pin" control={control} render={getControllerTextFieldRender({ label })} />
      </Grid>
      <Grid item mb={0.5}>
        <Button
          type="submit"
          appearance="primary"
          isLoading={isLoading}
          iconBefore={<EditorSearchIcon label="Search" />}
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};
